window.PreHireAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['PreHire']);

    self.getPreHireSettings = function (brandId, includeSchema) {
        var defer = $q.defer();
        includeSchema = includeSchema || false;
        var params = {
            include_schema: includeSchema
        };
        _protected.request("brands/" + brandId + "/settings", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.getPreHireApplicationsStatuses = function (brandId, channelCode, jobId, appIds) {
        var defer = $q.defer();
        var params = {
            ids: appIds.join(',')
        };
        _protected.request("brands/" + brandId + "/channels/" + channelCode + "/jobs/" + jobId + "/applications/statuses", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.sendApplicationsToPreHire = function (brandId, channelCode, jobId, applications) {
        var defer = $q.defer();
        var params = {
            applications: applications
        };
        _protected.request("brands/" + brandId + "/channels/" + channelCode + "/jobs/" + jobId + "/applications/send", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.PRE_HIRE_CHANNELS = {
        ULTIPRO: {'code': 'ULTIPRO', 'name': 'UKG'},
        PAYLOCITY: {'code': 'PAYLOCITY', 'name': 'Paylocity'},
        ALLIANCE: {'code': 'ALLIANCE', 'name': 'Alliance'},
    };

});
